import React, { CSSProperties } from 'react';

interface Props {
  style?: CSSProperties;
}

const RoundedSVG: React.FC<Props> = ({ style = {} }) => (
  <svg style={style} xmlns="http://www.w3.org/2000/svg" width="30.017" height="30.016" viewBox="0 0 30.017 30.016">
    <g id="Component_10_8" data-name="Component 10 – 8" transform="translate(0.5 0.5)">
      <path id="Path_794" data-name="Path 794" d="M182.508,890.02a14.508,14.508,0,1,0,14.508,14.508A14.524,14.524,0,0,0,182.508,890.02Z" transform="translate(-168 -890.02)" fill="none" stroke="#e2e2e2" strokeWidth="1" />
    </g>
  </svg>
);

export default RoundedSVG;